import { GetPaymentTradesApi } from "@/features/accounts/payment/scraping/services/get-trades-api";
import { GetPaymentTradesRequestModel } from "@/features/accounts/payment/scraping/services/get-trades-model";

/// Look明細一覧取得処理
export class GetPaymentTradesService {
  private getPaymentTradesApi = new GetPaymentTradesApi();

  /**
   * Look明細一覧取得API実行
   */
  public async getPaymentTrades(param: GetPaymentTradesRequestModel) {
    return await this.getPaymentTradesApi.getPaymentTrades(param);
  }
}
